import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import omit from 'lodash/omit';
import find from 'lodash/find';
import partition from 'lodash/partition';
import { FormControl } from '@cancercentrum/rcc-bootstrap';
import { useI18n } from '../i18n';
import { useRegvarValidator } from '../hooks/useRegvarValidator';
export const RegvarValueDomain = (props)=>{
    const { id, formatter = (x)=>x.text, options, optionsCaption, readOnly, inputRef, value, optionGroups, onChange, ...otherProps } = props;
    const val = useRegvarValidator();
    const onChangeHandler = (e)=>{
        const rawValue = parseInt(e.target.value, 10) || null;
        onChange(rawValue);
    };
    const { t } = useI18n();
    const rest = omit(otherProps, [
        'regvarMetadata'
    ]);
    const optionCaptionText = optionsCaption ? optionsCaption : t('regvar.list.caption');
    if (readOnly) {
        const item = find(options, (x)=>x.id === value);
        const text = item ? formatter(item) : optionCaptionText;
        return /*#__PURE__*/ _jsx("div", {
            ...omit(rest, val.getValidationPropNames()),
            className: "form-control-plaintext",
            children: text
        });
    }
    const getOptions = (opts)=>opts.reduce((reduction, item)=>{
            const text = formatter(item);
            return [
                ...reduction,
                /*#__PURE__*/ _jsx("option", {
                    value: item.id,
                    children: text
                }, item.id)
            ];
        }, []);
    let optionNodes;
    if (optionGroups) {
        let unused = [
            ...options
        ];
        optionNodes = optionGroups.reduce((res, og)=>{
            let opts;
            [opts, unused] = partition(unused, og.optionFilter);
            if (opts.length) {
                return [
                    ...res,
                    /*#__PURE__*/ _jsx("optgroup", {
                        label: og.text,
                        children: getOptions(opts)
                    }, og.text)
                ];
            }
            return res;
        }, []);
        if (unused.length) {
            optionNodes.push(/*#__PURE__*/ _jsx("optgroup", {
                label: t('regvar.list.other'),
                children: getOptions(unused)
            }, "ovriga_oanvanda"));
        }
    } else {
        optionNodes = getOptions(options);
    }
    return /*#__PURE__*/ _jsxs(FormControl, {
        componentClass: "select",
        className: "regvar-valuedomain__select",
        ...omit(rest, val.getValidationPropNames([
            'required',
            'min',
            'max'
        ])),
        id: id,
        value: value || '',
        onChange: onChangeHandler,
        ref: inputRef,
        children: [
            optionCaptionText && /*#__PURE__*/ _jsx("option", {
                value: "",
                children: optionCaptionText
            }),
            optionNodes
        ]
    });
};
export default /*#__PURE__*/ memo(RegvarValueDomain);
